module.exports = __webpack_public_path__ + "img/重庆石柱藤子沟国家湿地公园@2x.4531e305.png";